module.exports = __webpack_public_path__ + "static/img/finalregistration.e4d6ef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/finalregistration.png
// module id = ClQ3
// module chunks = 7